document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-button');
  const nav = document.querySelector('.primary-nav');

  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const status = carousel.querySelector('[data-carousel-status]');

    if (!track || slides.length < 2 || !prev || !next) return;

    let index = 0;
    const render = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      if (status) status.textContent = `${index + 1} / ${slides.length}`;
    };

    prev.addEventListener('click', () => {
      if (index > 0) {
        index -= 1;
        render();
      }
    });
    next.addEventListener('click', () => {
      if (index < slides.length - 1) {
        index += 1;
        render();
      }
    });
    render();
  });

  document.querySelectorAll('[data-hero-media-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-hero-media-track]');
    const slides = [...carousel.querySelectorAll('[data-hero-media-slide]')];
    const next = carousel.querySelector('[data-hero-media-next]');
    if (!track || slides.length < 2) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopCarousel = window.matchMedia('(min-width: 761px)');

    // Desktop uses a duplicated native visual track: the final frame and restart frame
    // are the same first image, so the carousel can only ever travel right-to-left.
    if (desktopCarousel.matches) {
      const firstClone = slides[0].cloneNode(true);
      firstClone.setAttribute('aria-hidden', 'true');
      firstClone.dataset.heroClone = 'first';
      track.append(firstClone);
      carousel.classList.add('hero-media-carousel--desktop-loop');
      next?.addEventListener('click', () => {
        const animation = track.getAnimations().find((item) => item.animationName === 'queen-bead-desktop-hero-loop');
        if (!animation || animation.currentTime === null) return;
        const cycle = 12000;
        const current = Number(animation.currentTime) % cycle;
        // Begin the next existing right-to-left segment without moving the current image backward.
        const target = current < 4000 ? 3400 : current < 8000 ? 7400 : 11400;
        animation.currentTime = Number(animation.currentTime) - current + target;
      });
      return;
    }

    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.dataset.heroClone = 'first';
    lastClone.dataset.heroClone = 'last';
    track.append(firstClone);
    track.prepend(lastClone);

    let index = 0;
    let timer;
    let touchStartX = null;
    let isMoving = false;

    const position = (slideIndex, animate = true) => {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = `translateX(-${(slideIndex + 1) * 100}%)`;
    };

    const announce = () => {
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== index));
      });
    };

    const afterSlideMotion = (callback) => {
      if (!desktopCarousel.matches) {
        window.setTimeout(callback, 620);
        return;
      }
      let finished = false;
      const complete = () => {
        if (finished) return;
        finished = true;
        callback();
      };
      track.addEventListener('transitionend', complete, { once: true });
      window.setTimeout(complete, 850);
    };

    const settleAt = (newIndex) => {
      index = newIndex;
      announce();
      afterSlideMotion(() => {
        position(index, false);
        requestAnimationFrame(() => {
          track.style.transition = '';
          isMoving = false;
        });
      });
    };

    const step = (direction) => {
      if (isMoving) return;
      isMoving = true;

      if (direction > 0 && index === slides.length - 1) {
        position(slides.length, true);
        settleAt(0);
        return;
      }

      if (direction < 0 && index === 0) {
        position(-1, true);
        settleAt(slides.length - 1);
        return;
      }

      index += direction;
      announce();
      position(index, true);
      afterSlideMotion(() => {
        isMoving = false;
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      stop();
      if (!reducedMotion.matches) timer = window.setInterval(() => step(1), 4000);
    };

    carousel.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0]?.clientX ?? null;
    }, { passive: true });

    carousel.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const distance = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 40) return;
      stop();
      step(distance < 0 ? 1 : -1);
      start();
    }, { passive: true });

    next?.addEventListener('click', () => {
      stop();
      step(1);
      start();
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    reducedMotion.addEventListener('change', start);

    position(index, false);
    announce();
    start();
  });
});
